import { ReactNode } from 'react';
import DateAdapter from '@mui/lab/AdapterDateFns';
import { LocalizationProvider } from '@mui/lab';
import { useTranslation } from 'react-i18next';
import { portalDateLocale } from './index';

/**
 * The MUI date pickers' localization, following the portal's language: month
 * and weekday names come from the date-fns locale loaded with the language's
 * chunk (i18n/bundles). In English no locale is passed, which is exactly the
 * provider index.tsx always rendered.
 */
export default function PortalLocalizationProvider({
  children,
}: {
  children: ReactNode;
}) {
  // Subscribes to language changes, so the pickers get the new locale (the
  // provider rebuilds its adapter when `locale` changes; nothing remounts,
  // so a booking in progress keeps every field).
  useTranslation();
  const locale = portalDateLocale();
  return (
    <LocalizationProvider
      dateAdapter={DateAdapter}
      locale={locale}
    >
      {children}
    </LocalizationProvider>
  );
}
